import * as React from 'react';
import { Typography } from "@mui/material";
import { CustomStackGrid } from "../../styles/style";
import { GradienCheckCircleIcon, GradienWarningIcon, GradienCancel2Icon, GradienCancelIcon } from "../../component/icons/icon-gradient";

export function CustomStatus(status) {
    switch (status) {
        case 'Online':
            return (
                <CustomStackGrid direction="row" spacing={1}>
                    <GradienCheckCircleIcon fontSize={20} />
                    <Typography variant="h6" sx={{ color: '#3dbb89' }}>{status}</Typography>
                </CustomStackGrid>
            );
        case 'Offline':
            return (
                <CustomStackGrid direction="row" spacing={1}>
                    <GradienCancel2Icon fontSize={20} />
                    <Typography variant="h6" sx={{ color: 'grey' }}>{status}</Typography>
                </CustomStackGrid>
            )
        case 'Warning':
            return (
                <CustomStackGrid direction="row" spacing={1}>
                    <GradienWarningIcon fontSize={20} />
                    <Typography variant="h6" sx={{ color: 'orange' }}>{status}</Typography>
                </CustomStackGrid>
            );
        case 'Error':
            return (
                <CustomStackGrid direction="row" spacing={1}>
                    <GradienCancelIcon fontSize={20} />
                    <Typography variant="h6" sx={{ color: 'red' }}>{status}</Typography>
                </CustomStackGrid>
            );
        default:
            break;
    }
}